import React from 'react'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import { SvgIconProps } from '@mui/material'

interface ViewItemProps {
  title: string
  text: string
  icon?: React.ReactElement<SvgIconProps>
  dense?: boolean
}

export const ViewItem: React.FC<ViewItemProps> = ({
  title,
  text,
  icon,
  dense = false
}) => {
  return (
    <ListItem dense={dense}>
      {icon && (
        <ListItemAvatar>
          <Avatar>{icon}</Avatar>
        </ListItemAvatar>
      )}
      <ListItemText primary={title} secondary={text} />
    </ListItem>
  )
}
